import types from './actions';

export default function reducer(state = {}, action) {
  switch (action.name) {
    case types.DOB_UPDATE_FAILED:
      return {
        ...state,
        gatingModal: {
          ...state.gatingModal,
          requestInProgress: false
        }
      };

    case types.DOB_UPDATE_REQUESTED:
      return {
        ...state,
        gatingModal: {
          ...state.gatingModal,
          requestInProgress: true
        }
      };

    case types.DOB_UPDATE_SUCCESS: {
      const { dateOfBirth, isTooYoung } = action;

      return {
        ...state,
        currentAthlete: { ...state.currentAthlete, dateOfBirth },
        gatingModal: {
          ...state.gatingModal,
          requestInProgress: !isTooYoung // stay busy until athlete is navigated away
        }
      };
    }

    case types.MODAL_CHANGE_DATE:
      return {
        ...state,
        gatingModal: {
          ...state.gatingModal,
          ageGate: {
            ...(state.gatingModal && state.gatingModal.ageGate),
            dateSelected: action.date
          }
        }
      };

    case types.MODAL_CLOSE:
      return {
        ...state,
        gatingModal: null
      };

    default:
      return state;
  }
}
